import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { NumericTextBox, TextArea } from "@progress/kendo-react-inputs";
import { Input } from "@progress/kendo-react-inputs";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toastr } from "react-redux-toastr";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { GridColumn } from "@progress/kendo-react-grid";
import Api from "../../Services/Api";
import moment from "moment";
import {CustomDateInput} from "../CustomDateInput";

const approvedList = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];

const STATUS = [
  { text: "Open", value: false },
  { text: "Closed", value: true },
];
export default class TaskRegisterFormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandMode: "multiple",
      customFieldReq: [],
      impactFieldReq: [],
      impactResponse: [],
      taskTitle: "",
      taskDescription: "",
      effort: 0,
      existingControl: "",
      taskOwner: {},
      isClosed: STATUS[0],
      percentageOnTrack: 0,
      percentageCompletion: 0,
      proximityAlertDate: null,
      originalCompletionDate: null,
      projectedCompletionDate: null,
      actualCompletionDate: null,
      delayConsequence: null,
      alertStakeHolders: [],
      alertDescription: "",
      postProbability: 0,
      currentProbability: 0,
      isDonePopulate: false,
      loader: false,
      isApproved: approvedList[1],
      formEditFlag: false,
      formData: {},
      temptaskTitle: false,
      impactslist: [],
      probabilityRangeMaster: {},
      weightageList: [],
      qualitativeImpactslist: [],
      openImpactRatingFlag: false,
      skip: 0,
      take: Math.round((window.innerHeight - 250) / 35),
      probabilityvalue: "",
      progressComment: "",
    };

    this.init = this.init.bind(this);
    this.getDisableFlagForSubmit = this.getDisableFlagForSubmit.bind(this);
  }

  getImpactRatingTable = async () => {
    try {
      this.setState({ loader: true });
      var req = {
        WorkstreamId: this.props.orgUnit.unitId,
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200 && response.impactRatingTable) {
        let wlist = response.impactRatios ? response.impactRatios : [];

        this.dynamicColsQuantitative(
          response.impactRatingTable,
          response.probabilityRangeResponse
        );
        this.dynamicColsQualititative(
          response.qualityimpactRatingTable,
          response.probabilityRangeResponse
        );

        let arr = response.probabilityRangeResponse;
        let array = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};
        let probabilityval = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        array = array?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;
          probabilityval = { ...probabilityval, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <GridColumn
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));
        let probabilityArray = array.map((column, index) => (
          <GridColumn
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));

        this.setState({
          ...this.state,
          loader: false,
          openImpactRatingFlag: true,
          impactslist: response.impactRatingTable,
          probabilityRangeMaster: [probabilityval],
          weightageList: wlist,
          qualitativeImpactslist: response.qualityimpactRatingTable,
          probabilityColumns: rangeArray,
          probabilityvalue: probabilityArray,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactslist: [],
          probabilityRangeMaster: [],
          weightageList: [],
          qualitativeImpactslist: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
        impactslist: [],
        probabilityRangeMaster: [],
        weightageList: [],
        qualitativeImpactslist: [],
      });
    }
  };
  dynamicColsQuantitative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  dynamicColsQualititative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getFieldName = (orderId, probabilityRangeResponse) => {
    let obj = probabilityRangeResponse.find((item) => item.orderId === orderId);
    return obj?.fullDescription;
  };
  //Triggred by parent
  loadEditmode = async (formData) => {
    await this.populateFormData(formData);
  };
  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  populateFormData = async (formData) => {
    try {
      let isApproved = approvedList.find(
        (item) => item.text === formData.isApproved
      );
      let isClosed = STATUS.find((item) => item.text === formData.isClosed);
      let taskOwner = this.props.ownerListForRisk.find(
        (item) => item.value === formData.ownerId
      );
      let priorityRanking = this.props.priorityRankingsList.find(
        (item) => item.value === formData.priorityRankingId
      );
      this.setState({
        ...this.state,
        formEditFlag: true,
        formData: formData,
        customFieldReq: await this.constructCFState(formData),
        // impactResponse: formData.impactResponse,
        taskTitle: formData.taskTitle,
        taskDescription: formData.taskDescription,
        isApproved: isApproved,
        cost: formData.cost,
        effort: formData.effort,
        taskOwner: taskOwner,
        isClosed: isClosed,
        percentageOnTrack: formData.percentageOnTrack,
        percentageCompletion: formData.percentageCompletion,
        proximityAlertDate: formData.proximityAlertDate
          ? new Date(formData.proximityAlertDate)
          : null,
        originalCompletionDate: formData.originalCompletionDate
          ? new Date(formData.originalCompletionDate)
          : null,
        projectedCompletionDate: formData.projectedCompletionDate
          ? new Date(formData.projectedCompletionDate)
          : null,
        actualCompletionDate: formData.actualCompletionDate
          ? new Date(formData.actualCompletionDate)
          : null,
        delayConsequence: formData.delayConsequence,
        progressComment: formData.progressComment,
        alertStakeHolders: this.processInput(formData.alertStakeHolders),
        alertDescription: formData.alertDescription,
        priorityRanking: priorityRanking,
        isDonePopulate: true,
        loader: false,
      });
    } catch (err) {
      console.error(err);
    }
  };
  constructCFState = (formData) => {
    let arr = [];
    try {
      formData.customFields.map((cf) => {
        let temp =
          this.props.orgUnit.customFields &&
          this.props.orgUnit.customFields.find(
            (item) => item.customFieldId === cf.id
          );
        // console.log("aaaa",aaaa);
        if (cf.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: temp.cfPossibleValues.filter((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.cfPossibleValues.find((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Free Text") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Numeric") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Date") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText ? new Date(cf.multiText) : null,
          });
        }
      });
      // this.setState({ ...this.state, customFieldReq: arr });
      return arr;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  handleCustomFieldValue = (e, CfItem) => {
    try {
      let cfObj = {
        CustomFieldId: CfItem.customFieldId,
        inputType: CfItem.inputType,
        value: CfItem.inputType === "Date" ? e.target.value : e.value,
      };
      let arr = this.state.customFieldReq;
      if (arr.some((item) => item.CustomFieldId === CfItem.customFieldId)) {
        let index = arr.findIndex(
          (item) => item.CustomFieldId == CfItem.customFieldId
        );
        arr[index] = cfObj;
      } else {
        arr.push(cfObj);
      }
      this.setState({ ...this.state, customFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };
  handleImpactFieldValue = (e, impact) => {
    try {
      let impactObj = {
        impactId: impact.impactId,
        impactType: impact.impactType,
        value: e.value,
      };
      let arr = this.state.impactFieldReq;
      if (arr.some((item) => item.impactId === impact.impactId)) {
        let index = arr.findIndex((item) => item.impactId == impact.impactId);
        // console.log("index", index);
        arr[index] = impactObj;
      } else {
        arr.push(impactObj);
      }
      // console.log("arr", arr);
      this.setState({ ...this.state, impactFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };

  saveTask = async () => {
    this.setState({ ...this.state, loader: true, isDonePopulate: true });
    try {
      let percentageCompletion = this.state.percentageCompletion;
      let isClosed = this.state.isClosed ? this.state.isClosed.value : false;
      let actualCompletionDate = this.state.actualCompletionDate;
      let projectedCompletionDate = this.state.projectedCompletionDate;
      let originalCompletionDate = this.state.originalCompletionDate;

      if (percentageCompletion >= 100) {
        isClosed = true;
        actualCompletionDate = new Date();
      }
      if (percentageCompletion >= 100 && !actualCompletionDate) {
        isClosed = true;
        actualCompletionDate = new Date();
      }

      if (actualCompletionDate) {
        isClosed = true;
      }
      if (isClosed === false) {
        actualCompletionDate = null;
      }
      if (this.state.originalCompletionDate && !projectedCompletionDate) {
        projectedCompletionDate = this.state.originalCompletionDate;
      }

      if (this.state.projectedCompletionDate && !originalCompletionDate) {
        originalCompletionDate = this.state.projectedCompletionDate;
      }

      let request = {
        taskRegisterId:
          this.state.formEditFlag === true
            ? this.state.formData.taskRegisterId
            : 0,
        organizationUnitId: this.props.orgUnit.unitId,
        TaskCustomFields: this.state.customFieldReq
          ? await this.changeCFKeyName(this.state.customFieldReq)
          : [],
        isApproved: this.state.isApproved ? this.state.isApproved.value : false,
        taskTitle: this.state.taskTitle?.slice(0, 30),
        taskDescription: this.state.taskDescription,
        cost: this.state.cost,
        effort: this.state.effort,
        taskOwner: this.state.taskOwner,
        isClosed: isClosed,
        percentageOnTrack:
          this.state.percentageOnTrack > 100
            ? 100
            : this.state.percentageOnTrack,
        percentageCompletion:
          percentageCompletion > 100 ? 100 : percentageCompletion,

        proximityAlertDate: this.state.proximityAlertDate
          ? moment(this.state.proximityAlertDate).format("YYYY-MM-DD")
          : null,
        originalCompletionDate: originalCompletionDate
          ? moment(originalCompletionDate).format("YYYY-MM-DD")
          : null,
        projectedCompletionDate: projectedCompletionDate
          ? moment(projectedCompletionDate).format("YYYY-MM-DD")
          : null,
        actualCompletionDate: actualCompletionDate
          ? moment(actualCompletionDate).format("YYYY-MM-DD")
          : null,

        delayConsequence: this.state.delayConsequence,
        alertStakeHolders: this.processInput(this.state.alertStakeHolders),
        alertDescription: this.state.alertDescription,
        priorityRankingId: this.state.priorityRanking?.value,

        progressComment: this.state.progressComment,
      };
      let response = await Api.addTaskRegisterAsync(request);
      if (response.status === 200) {
        toastr.success(response.message);
        await this.init("RESET");
        if (request.number) {
          this.props.addRiskDataFromForm("UPDATE", response.riskReg);
          this.init("CANCEL");
        } else {
          this.props.addRiskDataFromForm("ADD", response.riskReg);
          this.init("CANCEL");
        }
        this.setState({ ...this.state, loader: false });
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  changeCFKeyName = (cfArray) => {
    let arr = [];
    try {
      cfArray.forEach((element) => {
        if (element.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            MultiDropDownValue: element.value,
          });
        } else if (element.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            SingleDropDownValue: element.value,
          });
        } else if (element.inputType == "Free Text") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            FreeTextValue: element.value,
          });
        } else if (element.inputType == "Numeric") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            NumericValue: element.value,
          });
        } else if (element.inputType == "Date") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            DateValue: element.value,
          });
        }
      });
    } catch (err) {
      console.error(err);
    }
    return arr;
  };
  getCFValue = (cf) => {
    try {
      let obj =
        this.state.customFieldReq &&
        this.state.customFieldReq.find(
          (item) => item.CustomFieldId === cf.customFieldId
        );

      if (obj) {
        return obj.value;
      } else {
        return "";
      }
    } catch (err) {
      console.error(err);
    }
    return;
  };
  getImpactValue = (impact) => {
    try {
      let impactObj = this.state.impactFieldReq.find(
        (item) => item.impactId === impact.impactId
      );
      if (impactObj && impact.impactType === "Quantitative") {
        return impactObj.value;
      } else if (impactObj && impact.impactType === "Qualitative") {
        return impactObj.qValue ? impactObj.qValue : impactObj.value;
      }
    } catch (err) {
      console.error(err);
    }
    return 0;
  };

  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  init = async (flag) => {
    if (flag == "CANCEL") {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        taskTitle: "",
        taskDescription: "",
        cost: 0,
        effort: 0,
        existingControl: "",
        taskOwner: {},
        priorityRanking: null,
        isClosed: STATUS[0],
        percentageOnTrack: 0,
        percentageCompletion: 0,
        proximityAlertDate: null,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        delayConsequence: null,
        alertStakeHolders: [],
        alertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        isDonePopulate: false,

        formEditFlag: false,
        loader: false,
      });
      this.props.closeRiskFormView();
    } else {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        taskTitle: "",
        taskDescription: "",
        cost: 0,
        effort: 0,
        existingControl: "",
        taskOwner: {},
        priorityRanking: null,
        isClosed: STATUS[0],
        percentageOnTrack: 0,
        percentageCompletion: 0,
        proximityAlertDate: null,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        delayConsequence: null,
        alertStakeHolders: [],
        alertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        formEditFlag: false,
        loader: false,
      });
    }
  };

  getImpactCurrentAndPostValue = (impact, type) => {
    try {
      if (this.state.formEditFlag === true) {
        let impactObj =
          this.state.impactResponse &&
          this.state.impactResponse.find(
            (item) => item.impactId === impact.impactId && item.type === type
          );
        if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.currentImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.postImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.currentQvalue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.postQvalue;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  riskalertstakeholderValue = (e, values) => {
    var val = [];
    val = values[values.length - 1];
    let mailvalidity = /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;

    if (
      val &&
      (val.trim().length == 0 ||
        (!(val.includes("(") && val.includes(")")) &&
          mailvalidity.test(val) == false))
    ) {
      toastr.error("Please enter a valid email address");
    } else {
      this.setState({
        ...this.state,
        alertStakeHolders: values,
      });
    }
  };

  taskTitleValue = (e) => {
    var val = e.target.value.trim();
    if (val == 0) {
      this.setState({
        ...this.state,
        taskTitle: e.target.value,
        temptaskTitle: true,
      });
    } else {
      this.setState({
        ...this.state,
        taskTitle: e.target.value,
        temptaskTitle: false,
      });
    }
  };

  getDisableFlag = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.ownerId;
    const role = this.state.formData.roleName;
    const taskActionCount = this.state.formData.taskActionCount;
    const isClosed =
      this.state.isClosed.value === true ||
      this.state.isClosed.value === "Closed"
        ? true
        : false;
    if (isClosed === true) {
      flag = true;
    } else if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    }
    //  else if(taskActionCount>0){
    //   flag = true;
    // }
    return flag;
  };

  getDisableFlagForSubmit = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.ownerId;
    const role = this.state.formData.roleName;
    // const taskActionCount=this.state.formData.taskActionCount;

    if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    } else if (!this.state.taskTitle || this.state.taskTitle === "") {
      flag = true;
    }
    // else if(taskActionCount>0){
    //   flag = true;
    // }
    return flag;
  };

  impactRatingClose = () => {
    this.setState({ openImpactRatingFlag: false });
  };
  openImpactRatingTable = () => {
    this.getImpactRatingTable();
  };
  pageChange = (event) => {
    this.setState({ skip: event.page.skip, take: event.page.take });
  };
  progressHistory = () => {
    this.setState({ ...this.state, progressStatusFlag: true });
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false });
  };

  isHiddenTaskColumn = (field) => {
    return !this.props.selectedTasksColumnFields?.some(
      (item) => item.fieldName === field
    );
  };
  render() {
    const { expandMode } = this.state;
    const isDisabled = this.getDisableFlag();
    const taskActionCount = this.state.formData.taskActionCount || 0;
    return (
      <div>
        <Popup
          show={this.props.showFormView}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="addriskFormview">
            <div className="Formview">
              <h3>
                {this.state.formEditFlag === true
                  ? "Update Task - " + this.state.formData.taskNumber
                  : "Add Task"}{" "}
              </h3>
              {/* <div className="RatingTablebtn" title="Rating Table">
                <a onClick={() => this.openImpactRatingTable()}>Rating Table</a>
              </div> */}
            </div>
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <PanelBar expandMode={expandMode}>
              <PanelBarItem title={"Task Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div className="fieldCont" title={this.state.taskTitle}>
                      <label>Task Title *</label>

                      <Input
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            taskTitle: e.value,
                          });
                        }}
                        value={
                          this.state.taskTitle
                            ? this.state.taskTitle.trimStart()
                            : ""
                        }
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  {this.isHiddenTaskColumn("taskDescription") && (
                    <div className="riskCol col6">
                      <div
                        className="fieldCont"
                        title={this.state.taskDescription}
                      >
                        <label>Task Description</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              taskDescription: e.value,
                            });
                          }}
                          value={this.state.taskDescription}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  {/* <div className="riskCol col2">
                    <div className="fieldCont">
                      <label>Approved</label>
                      <DropDownList
                        style={{ width: "100px" }}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            isApproved: e.target.value,
                          });
                        }}
                        data={approvedList}
                        valueField="value"
                        textField="text"
                        value={this.state.isApproved}
                        disabled={isDisabled}
                      />
                    </div>
                  </div> */}
                  {this.isHiddenTaskColumn("priorityRankingName") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Priority Ranking</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              priorityRanking: e.target.value,
                            });
                          }}
                          value={this.state.priorityRanking}
                          disabled={isDisabled || taskActionCount > 0}
                          data={
                            this.props ? this.props.priorityRankingsList : []
                          }
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className="riskRow"> */}
                {/* <div className="riskCol col4">
                    <div className="fieldCont" title={this.state.cost}>
                      <label>
                        Cost of Task / {secureLocalStorage.getItem("currency")}
                      </label>
                      <NumericTextBox
                        value={this.state.cost}
                        disabled={isDisabled || taskActionCount>0}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            cost: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div> */}
                {/* <div className="riskCol col4">
                    <div className="fieldCont" title={this.state.effort}>
                      <label>
                        Effort / {this.props.orgUnit.effortUnitName||"Days"}
                      </label>

                      <NumericTextBox
                        value={this.state.effort}
                        disabled={isDisabled|| taskActionCount>0}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            effort: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div> */}

                {/* </div> */}
                <div className="riskRow">
                  {this.isHiddenTaskColumn("delayConsequence") && (
                    <div className="riskCol col3">
                      <div
                        className="fieldCont"
                        title={this.state.delayConsequence}
                      >
                        <label>Delay Consequence</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              delayConsequence: e.value,
                            });
                          }}
                          value={this.state.delayConsequence}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenTaskColumn("progressComment") && (
                    <div className="riskCol col3">
                      <div
                        className="fieldCont"
                        title={this.state.progressComment}
                      >
                        <label>Progress Status</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              progressComment: e.value,
                            });
                          }}
                          value={this.state.progressComment}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.formEditFlag === true &&
                    this.isHiddenTaskColumn("progressComment") && (
                      <div className="riskCol col2">
                        <div
                          className="fieldCont progressHistory"
                          title="Progress History"
                          style={{ marginTop: "26px" }}
                        >
                          <button
                            className="btnPrimary"
                            onClick={() => this.progressHistory()}
                          >
                            Progress History
                          </button>
                        </div>
                      </div>
                    )}
                  {this.isHiddenTaskColumn("taskOwnerName") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Task Owner</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              taskOwner: e.target.value,
                            });
                          }}
                          value={this.state.taskOwner}
                          disabled={isDisabled}
                          data={this.props ? this.props.ownerListForRisk : []}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenTaskColumn("isClosed") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Status</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          disabled={
                            this.state.formData.roleName === "View Only" ||
                            this.state.formData.roleName === "Standard User"
                          }
                          value={this.state.isClosed}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              isClosed: e.target.value,
                            });
                          }}
                          data={STATUS}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Custom Fields"}>
                <div className="riskRow">
                  {this.props.orgUnit &&
                    this.props.orgUnit.customFields &&
                    this.props.orgUnit.customFields.map((CfItem) => {
                      if (
                        CfItem.inputType === "Numeric" &&
                        this.isHiddenTaskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <NumericTextBox
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Free Text" &&
                        this.isHiddenTaskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div
                              className="fieldCont"
                              title={this.getCFValue(CfItem)}
                            >
                              <label>{CfItem.fieldName}</label>
                              <TextArea
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Date" &&
                        this.isHiddenTaskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>

                              <DatePicker
                                format="dd-MMM-yyyy"
                                id="datefield"
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Single Drop Down" &&
                        this.isHiddenTaskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <DropDownList
                                style={{ width: "100px" }}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                data={
                                  CfItem.cfPossibleValues
                                    ? [
                                        {
                                          hashValue: "",
                                          id: 0,
                                          possibleValues: " [blank]",
                                        },
                                      ].concat(CfItem.cfPossibleValues)
                                    : []
                                }
                                valueField="id"
                                textField="possibleValues"
                              />
                            </div>
                          </div>
                        );
                      } else if (
                        CfItem.inputType === "Multi Drop Down" &&
                        this.isHiddenTaskColumn(CfItem.fieldName)
                      ) {
                        return (
                          <div
                            className="riskCol col3"
                            key={CfItem.customFieldId}
                          >
                            <div className="fieldCont">
                              <label>{CfItem.fieldName}</label>
                              <MultiSelect
                                style={{ width: "100px !important" }}
                                onChange={(e) =>
                                  this.handleCustomFieldValue(e, CfItem)
                                }
                                // onBlur={this.handleChangeBlur}
                                itemRender={this.itemRender}
                                value={this.getCFValue(CfItem)}
                                disabled={isDisabled}
                                id="customeFieldId"
                                data={
                                  CfItem.cfPossibleValues
                                    ? CfItem.cfPossibleValues
                                    : []
                                }
                                valueField="id"
                                textField="possibleValues"
                                autoClose={false}
                                // tags={
                                //   selected > 0
                                //     ? [{ text: `${selected} items selected`, data: [...value] }]
                                //     : []
                                // }
                              />
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </PanelBarItem>
              {/* <PanelBarItem title={"Task Progress"}>
                <div className="riskRow">
                <div className="riskCol col3">
                    <div
                      className="fieldCont"
                      title={this.state.percentageOnTrack}
                    >
                      <label>% on Track</label>

                      <NumericTextBox
                        value={
                          this.state.percentageOnTrack > 100
                            ? 100
                            : this.state.percentageOnTrack
                        }
                        disabled={isDisabled|| taskActionCount>0}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            percentageOnTrack: e.target.value,
                          });
                        }}
                        min={0}
                        max={100}
                      />
                    </div>
                  </div>
                  <div className="riskCol col3">
                    <div
                      className="fieldCont"
                      title={this.state.percentageCompletion}
                    >
                      <label>% Completion</label>

                      <NumericTextBox
                        value={
                          this.state.percentageCompletion > 100
                            ? 100
                            : this.state.percentageCompletion
                        }
                        disabled={isDisabled|| taskActionCount>0}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            percentageCompletion: e.target.value,
                          });
                        }}
                        min={0}
                        max={100}
                      />
                    </div>
                  </div>
                </div>
                <div className="riskRow">
                  <div className="riskCol col3">
                    <div className="fieldCont">
                      <label>Original Completion Date</label>
                      <DatePicker
                        format="dd-MMM-yyyy"
                        id="datefield"
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            originalCompletionDate: e.target.value,
                          });
                        }}
                        value={this.state.originalCompletionDate}
                        disabled={isDisabled|| taskActionCount>0}
                      />
                    </div>
                  </div>
                  <div className="riskCol col3">
                    <div className="fieldCont">
                      <label>Projected Completion Date</label>
                      <DatePicker
                        format="dd-MMM-yyyy"
                        id="datefield"
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            projectedCompletionDate: e.target.value,
                          });
                        }}
                        value={this.state.projectedCompletionDate}
                        disabled={isDisabled|| taskActionCount>0}
                      />
                    </div>
                  </div>
                  <div className="riskCol col3">
                    <div className="fieldCont">
                      <label>Actual Completion Date</label>
                      <DatePicker
                        format="dd-MMM-yyyy"
                        id="datefield"
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            actualCompletionDate: e.target.value,
                            // isClosed:STATUS[1]
                          });
                        }}
                        value={this.state.actualCompletionDate}
                        disabled={isDisabled|| taskActionCount>0}
                      />
                    </div>
                  </div>
                </div>
               
              </PanelBarItem> */}
              <PanelBarItem title={"Proximity Alert"}>
                <div className="riskRow">
                  {this.isHiddenTaskColumn("proximityAlertDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Proximity Alert Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              proximityAlertDate: e.target.value,
                            });
                          }}
                          value={this.state.proximityAlertDate}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenTaskColumn("alertStakeHolders") && (
                    <div className="riskCol col3">
                      <div className="fieldCont" style={{ marginTop: "15px" }}>
                        <label>Alert Stakeholders</label>
                        <Autocomplete
                          multiple
                          id="emailbcc"
                          // autoSelect={true}
                          options={this.props.dropDownData.map(
                            (option) => option.displayName
                          )}
                          freeSolo
                          disableCloseOnSelect
                          onChange={this.riskalertstakeholderValue}
                          disabled={isDisabled}
                          value={this.state.alertStakeHolders}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          PaperComponent={({ children }) => (
                            <div className="paperComponent">
                              <span>{children}</span>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} variant="filled" />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenTaskColumn("alertDescription") && (
                    <div className="riskCol col5">
                      <div
                        className="fieldCont textarea-large"
                        title={this.state.alertDescription}
                      >
                        <label>Alert Description</label>
                        <TextArea
                          value={this.state.alertDescription}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              alertDescription: e.value,
                            });
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
            </PanelBar>
            <div className="btnGroup">
              <button
                type="button"
                onClick={this.saveTask}
                className="btnPrimary"
                disabled={this.getDisableFlagForSubmit()}
              >
                {this.state.formEditFlag === true ? "Update" : "Add"}
              </button>
              <button
                className="btnPrimary"
                onClick={() => this.init("CANCEL")}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.formData?.taskProgressComments?.map((item) => (
                  <li>
                    <p>{item.taskComment}</p>
                    <small>
                      Date:
                      {moment(new Date(item.createdDate)).format(
                        "DD-MMM-yyyy HH:mm:ss"
                      )}
                    </small>{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <small>Entered by:{item.userName}</small>
                  </li>
                ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
